import Dexie, { Table } from 'dexie';

export interface EncryptedLogWrapper {
  id?: number; // Auto-incremented key
  timestamp: string; // ISO string
  encrypted: string; // Base64 encoded encrypted string
}

export class LogDatabase extends Dexie {
  logs!: Table<EncryptedLogWrapper>;

  constructor() {
    super('LogDatabase');
    this.version(1).stores({
      logs: '++id,timestamp', // auto ID and index on timestamp
    });
  }
}

export const logDB = new LogDatabase();